import { useTrustpilotScore } from '@cinch-nx/data-trustpilot'
import { Env, readFromEnv } from '@cinch-nx/environments'
import { TrustpilotScoreless, Wrapper } from '@cinch-nx/shared-ui'
import { useMemo } from 'react'
import { TrustpilotOverviewV2 } from '../../index'

export const MINIMUM_TRUSTPILOT_SCORE = 4.3

export interface TrustpilotProps {
  className?: string
  numberOfReviews: number
  starRating: number
  starRatingLabel: string
}

export default function Trustpilot({
  numberOfReviews,
  starRating,
  starRatingLabel,
  className,
}: TrustpilotProps) {
  const trustpilotScore = useTrustpilotScore()
  const showScorelessTrustpilot = useMemo(
    () => readFromEnv(Env.ShowScorelessTrustpilot) === 'true',
    [],
  )

  if (!trustpilotScore || trustpilotScore < MINIMUM_TRUSTPILOT_SCORE) {
    return null
  }

  return (
    <Wrapper className={{ inner: className }}>
      {showScorelessTrustpilot ? (
        <TrustpilotScoreless numberOfReviews={numberOfReviews} />
      ) : (
        <TrustpilotOverviewV2
          starRating={starRating}
          starRatingLabel={starRatingLabel}
          numberOfReviews={numberOfReviews}
        />
      )}
    </Wrapper>
  )
}
